import React from 'react';
import { CheckIcon, CreditCardIcon, WalletIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { Reveal } from './Reveal';
import { pricingIncludes } from '../data/content';
export function Pricing() {
  return <section id="pricing" className="w-full scroll-mt-16 bg-white px-5 py-20 sm:px-8" data-id="element-147" data-mp="2oi7gnjrerqz2">
      <div className="mx-auto w-full max-w-2xl" data-id="element-148" data-mp="2jkxj1gtv8905">
        <Reveal data-id="element-149" data-mp="1vu1v4usj5xy6">
          <h2 className="text-center font-display text-3xl font-extrabold leading-tight tracking-tight text-navy sm:text-4xl" data-id="element-150" data-mp="1vtiav7feqxgz">
            Everything included,{' '}
            <span className="text-cheer" data-id="element-151" data-mp="1ruj7hr9br8rn">one single price</span>.
          </h2>
        </Reveal>

        <Reveal delay={0.06} data-id="element-152" data-mp="25q4w3xbnbqjj">
          <div className="relative mt-12 overflow-hidden rounded-card border border-navy/10 bg-white shadow-card" data-id="element-153" data-mp="20tejjjz1vd2v">
            <div className="flex justify-center" data-id="element-154" data-mp="3h6le9yel4la3">
              <p className="rounded-b-xl bg-gold px-6 py-2 text-[11px] font-bold uppercase tracking-widest text-navy" data-id="element-155" data-mp="3h9hclnuchbz2">
                Best value
              </p>
            </div>

            <div className="px-6 py-10 sm:px-12" data-id="element-156" data-mp="3vz71hz8o4rqj">
              <h3 className="text-center font-display text-xl font-extrabold uppercase leading-snug tracking-tight text-navy sm:text-2xl" data-id="element-157" data-mp="4smeqrpnc5zb">
                Cheerleading Ready 360 — Complete Pack
              </h3>

              <p className="mt-8 text-center text-sm font-semibold text-navy/50" data-id="element-158" data-mp="erlflo466xbr">
                <span className="line-through" data-id="element-159" data-mp="3d9h8nhogug19">$109</span>
              </p>
              <p className="mt-1 text-center font-display text-7xl font-black leading-none tracking-tight text-cheer" data-id="element-160" data-mp="3d74gycsworb0">
                $22
              </p>
              <p className="mt-3 text-center text-sm font-semibold text-navy/70" data-id="element-161" data-mp="3n6d86xwdzrto">
                One-time payment, lifetime access.
              </p>

              <ul className="mx-auto mt-10 grid gap-3 sm:grid-cols-2" data-id="element-162" data-mp="2uihg66hrio38">
                {pricingIncludes.map(item => <li key={item} className="flex items-center gap-2.5" data-id="element-163" data-mp="2zgr9scnu9gmq">
                    <CheckIcon className="h-4 w-4 shrink-0 text-cheer" aria-hidden="true" data-id="element-164" data-mp="2rgv09f5lnye9" />
                    <span className="text-sm font-semibold text-navy" data-id="element-165" data-mp="2mh8nf6took5z">{item}</span>
                  </li>)}
              </ul>

              <div className="mt-10" data-id="element-166" data-mp="2w7l3alqjzp5s">
                <CtaButton data-id="element-167" data-mp="2w8mi91aowvss" />
              </div>

              <p className="mt-5 text-center text-xs font-semibold text-navy/60" data-id="element-168" data-mp="2w9xn74fvg9lh">
                Secure payment · Instant delivery to your email
              </p>
              <ul className="mt-3 flex items-center justify-center gap-5 text-navy/50" data-id="element-169" data-mp="23kgwcb7wh0rd">
                <li className="flex items-center gap-1.5 text-xs font-semibold" data-id="element-170" data-mp="2igy6x089mbcv">
                  <CreditCardIcon className="h-4 w-4" aria-hidden="true" data-id="element-171" data-mp="2dgtyzylfaoy9" /> Card
                </li>
                <li className="flex items-center gap-1.5 text-xs font-semibold" data-id="element-172" data-mp="3tuk51aw3rnaj">
                  <WalletIcon className="h-4 w-4" aria-hidden="true" data-id="element-173" data-mp="3owiksmmxxhxh" /> PayPal
                </li>
              </ul>
            </div>
          </div>
        </Reveal>
      </div>
    </section>;
}